import React from 'react';
import { Modal, Spin } from 'antd';
import { useTranslation } from 'react-i18next';
import { useStudentImport } from '../hooks/useStudentImport';
import ImportUploader from './ImportUploader';
import ImportNotice from './ImportNotice';
import ImportResultTable from './ImportResultTable';
import CustomButton from 'components/Common/ui/CustomButton';
import CustomModal from 'components/Common/CustomModal';

interface StudentImportModalProps {
  onImportSuccess?: () => void;
}

const StudentImportModal: React.FC<StudentImportModalProps> = ({ onImportSuccess }) => {
  const { t } = useTranslation();
  const {
    open,
    setOpen,
    csvFile,
    setCsvFile,
    loading,
    importResult,
    handleUpload,
    handleSubmit,
    reset
  } = useStudentImport();

  const onSubmitClick = async () => {
    await handleSubmit(t);
    onImportSuccess?.();
  };

  return (
    <>
      <CustomButton
        onClick={() => setOpen(true)}
      >
        <i className="ti ti-upload me-2" />
        {t('import_button_open')}
      </CustomButton>

      <CustomModal
        title={t('import_modal_title')}
        isOpen={open}
        onClose={() => setOpen(false)}
      >
        <ImportNotice file="/assets/templates/student-import-model.xlsx" />
        <ImportUploader
          csvFile={csvFile}
          handleUpload={handleUpload}
          setCsvFile={setCsvFile}
        />

        {loading && <Spin style={{ marginTop: 16 }} />}

        {importResult && (
          <ImportResultTable
            errors={importResult.errors}
            created={importResult.created}
            skipped={importResult.skipped}
          />
        )}

        <div className="d-flex justify-content-end mt-4 gap-2">
          <CustomButton
            onClick={reset}
            disabled={loading}
            variant="light"
          >
            {t('import_button_reset')}
          </CustomButton>
          <CustomButton
            onClick={onSubmitClick}
            disabled={!csvFile || loading}
          >
            {t('import_button_submit')}
          </CustomButton>
        </div>
      </CustomModal>
    </>
  );
};

export default StudentImportModal;
